import React from 'react';

import { StyledTextBody } from './TextBody.styles';
import { ITextBodyProps } from './TextBody.types';

const TextBody = ({
  children,
  className,
  tag,
}: ITextBodyProps): JSX.Element => {
  return (
    <StyledTextBody tag={tag} className={className}>
      {children}
    </StyledTextBody>
  );
};

export default TextBody;
